import { v4 as uuidv4 } from 'uuid';

export function FormFieldGroup(props = {}, childrenComponents = [], blocks = []) {
	return {
		componentName: 'FormFieldGroup',
		componentId: uuidv4(),
		props: Object.assign(
			{
				pointer: '',
				uiSchema: '',
			},
			props,
		),
		childrenComponents,
		blocks,
	};
}
